/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Dropdown, TextInput, isEmptyValue, TextboxInput, composeValidators } from '@blend/enterprise-components';
import { WrappedInput } from 'blb-components/WrappedInput';
const RECIPIENTS = [{
  text: 'Loan Officer',
  value: 'LOAN_OFFICER'
}];
const THREAD_TOPICS = [{
  text: 'Title',
  value: 'TITLE'
}, {
  text: 'Fee Collaboration',
  value: 'FEE_COLLABORATION'
}, {
  text: 'Processing',
  value: 'PROCESSING'
}, {
  text: 'Scheduling Closing',
  value: 'SCHEDULING_CLOSING'
}, {
  text: 'Funding',
  value: 'FUNDING'
}, {
  text: 'Post-Closing',
  value: 'POST_CLOSING'
}, {
  text: 'Other',
  value: 'OTHER'
}];
export const subjectInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Subject',
  name: 'subject',
  validate: isEmptyValue('Please provide a message subject')
};
export const recipientInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    options: RECIPIENTS
  },
  hideLabel: true,
  inputComponent: Dropdown,
  label: 'To',
  name: 'recipient',
  validate: isEmptyValue('Please provide a recipient')
};
export const topicInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    options: THREAD_TOPICS
  },
  hideLabel: true,
  inputComponent: Dropdown,
  label: 'Topic',
  name: 'topic',
  validate: isEmptyValue('Please provide a topic')
};
export const messageInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    rows: 8,
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextboxInput,
  label: 'Message',
  name: 'message',
  validate: composeValidators(isEmptyValue('Please provide a message body'), value => {
    return !!value && value.length > 1024 * 3 ? 'Please keep the message less than 3072 characters' : undefined;
  })
};